import React from 'react';
import { Box, Flex, Heading, Spacer, useBreakpointValue, HStack, Link } from '@chakra-ui/react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { TimezoneSelect } from './common/TimezoneSelect';

export const AppHeader: React.FC = () => {
  const headingSize = useBreakpointValue({ base: 'sm', md: 'md' });
  const location = useLocation();

  const isTradingPage = location.pathname === '/trading' || location.pathname.startsWith('/trading/');
  const isDexchTradingPage = location.pathname === '/dexch-trading' || location.pathname.startsWith('/dexch-trading/');

  return (
    <Box bg="blue.500" px={{ base: 3, md: 4 }} py={2} position="sticky" top="0" zIndex="sticky">
      <Flex alignItems="center">
        <Heading size={headingSize} color="white">Admin Dashboard</Heading>
        <Spacer />
        <HStack spacing={4}>
          {isDexchTradingPage ? (
            // Don't show any menu items for Dexch Trading pages
            null
          ) : isTradingPage ? (
            <Link
              as={RouterLink}
              to="/trading"
              color="white"
              fontWeight="bold"
              textDecoration="underline"
            >
              Trading
            </Link>
          ) : (
            <>
              <Link
                as={RouterLink}
                to="/events"
                color="white"
                fontWeight={location.pathname === '/events' ? 'bold' : 'normal'}
                textDecoration={location.pathname === '/events' ? 'underline' : 'none'}
              >
                Events
              </Link>
              <Link
                as={RouterLink}
                to="/trading"
                color="white"
                fontWeight={location.pathname === '/trading' || location.pathname.startsWith('/trading/') ? 'bold' : 'normal'}
                textDecoration={location.pathname === '/trading' || location.pathname.startsWith('/trading/') ? 'underline' : 'none'}
              >
                Trading
              </Link>
              <Link
                as={RouterLink}
                to="/fls-dashboard"
                color="white"
                fontWeight={location.pathname === '/fls-dashboard' ? 'bold' : 'normal'}
                textDecoration={location.pathname === '/fls-dashboard' ? 'underline' : 'none'}
              >
                FLS Dashboard
              </Link>
              <Link
                as={RouterLink}
                to="/market-controls"
                color="white"
                fontWeight={location.pathname === '/market-controls' ? 'bold' : 'normal'}
                textDecoration={location.pathname === '/market-controls' ? 'underline' : 'none'}
              >
                Market Controls
              </Link>
              <Link
                as={RouterLink}
                to="/template-prices"
                color="white"
                fontWeight={location.pathname === '/template-prices' ? 'bold' : 'normal'}
                textDecoration={location.pathname === '/template-prices' ? 'underline' : 'none'}
              >
                Template Prices
              </Link>
            </>
          )}
          <TimezoneSelect size="sm" width="auto" maxWidth="200px" bg="white" />
        </HStack>
      </Flex>
    </Box>
  );
};
